import React from 'react';
import { Link } from 'react-router-dom';

export function LogoMark({ className = 'w-10 h-10', dark = false }) {
  return (
    <div className={`${className} relative rounded-xl ${dark ? 'bg-white' : 'bg-navy'} flex items-center justify-center overflow-hidden`}>
      <svg viewBox="0 0 40 40" className="w-[70%] h-[70%]" fill="none">
        <circle cx="13" cy="16" r="6" stroke={dark ? '#071A3A' : '#19D3FF'} strokeWidth="2.5" />
        <circle cx="27" cy="16" r="6" stroke={dark ? '#071A3A' : '#fff'} strokeWidth="2.5" />
        <path d="M13 22v4a7 7 0 0 0 14 0v-4" stroke={dark ? '#0B5CFF' : '#0B5CFF'} strokeWidth="2.5" strokeLinecap="round" />
        <circle cx="20" cy="33" r="2.4" fill={dark ? '#0B5CFF' : '#19D3FF'} />
      </svg>
    </div>
  );
}

export default function Logo({ dark = false, compact = false }) {
  return (
    <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
      <LogoMark dark={dark} />
      {!compact && (
        <div className="leading-none">
          <div className={`font-display font-extrabold text-[15px] tracking-tight ${dark ? 'text-white' : 'text-navy'}`}>
            TOP 3 <span className="text-royal">FOOTBALL</span>
          </div>
          <div className={`eyebrow mt-1 ${dark ? 'text-white/50' : 'text-slate-500'}`}>Football Tipsters</div>
        </div>
      )}
    </Link>
  );
}
